import { makeAutoObservable } from "mobx";
/*
  Parametrized modifier instance editability class to optimize unification - calculated once for all ModifierItemInstanceCreators
*/
export class ModifierInstanceCreatorEditability {
    constructor(editabilityParametrization, creatorScopeProvider) {
        this.editabilityParametrization = editabilityParametrization;
        this.creatorScopeProvider = creatorScopeProvider;
        makeAutoObservable(this);
    }
    get isEditable() {
        return this.editabilityParametrization.unify(this.creatorScopeProvider.parameterSet);
    }
    get isPossiblyEditable() {
        return this.isEditable.isValuePossible(true);
    }
    clone(creatorScopeProvider) {
        return new ModifierInstanceCreatorEditability(this.editabilityParametrization, creatorScopeProvider);
    }
}
